export default {
	props: { param: { type: Object } },
};
